module Meevo.Components.Common {
    export class TippyDataService {
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings, protected $http: angular.IHttpService) {
            
        }

        /**
        * Retrieves a maintenance form section for an item matching the supplied id at the specified endpoint.
        * @param {string} endpoint
        * @return {IPromise<any>}
        */
        getSection(baseEndpoint: string, sectionEndpoint: string): angular.IPromise<any> {
            return this.$http.get(`${window["TippyMicroserviceUrl"]}/${sectionEndpoint}`, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json;charset=utf-8"
                    , "Authorization": `Bearer ${window['bearerToken']}`
                }
            })
                .then((response) => response.data);
        }

        getSectionById(baseEndpoint: string, id: Guid, sectionEndpoint: string): angular.IPromise<any>;
        getSectionById(baseEndpoint: string, id: Guid, sectionEndpoint: string, asLocationId?: number): angular.IPromise<any> {
            return this.$http.get(`${window["TippyMicroserviceUrl"]}/${id}/${sectionEndpoint}`, this.getShortcutConfig())
                .then((response) => response.data);
        }

        // timeoutMs is opt-in (only the kiosk-lock checks pass one) - other callers (e.g. getTippyMode)
        // keep the default $http behavior with no timeout.
        getKioskByDrawerId(drawerId: string, timeoutMs?: number): angular.IPromise<any> {
            const config = this.getShortcutConfig();
            if (timeoutMs) {
                config.timeout = timeoutMs;
            }
            return this.$http.get(`${window["TippyMicroserviceUrl"]}/kiosks?drawerId=${drawerId}`, config)
                .then((response) => {
                    let kiosks = <Model.TippyKiosk[]>response.data;
                    return kiosks.length > 0 ? kiosks[0] : null;
                });
        }

        getKioskByDeviceId(deviceId: string, timeoutMs?: number): angular.IPromise<any> {
            const config = this.getShortcutConfig();
            if (timeoutMs) {
                config.timeout = timeoutMs;
            }
            return this.$http.get(`${window["TippyMicroserviceUrl"]}/kiosks?deviceId=${deviceId}`, config)
                .then((response) => {
                    let kiosks = <Model.TippyKiosk[]>response.data;
                    return kiosks.length > 0 ? kiosks[0] : null;
                });
        }

        addKiosk(drawerId: string, deviceId: string): angular.IPromise<any> {
            return this.$http.post(`${window["TippyMicroserviceUrl"]}/kiosk/${deviceId}`, 
                {
                    drawerId: drawerId
                }, this.getShortcutConfig())
                .then((response) => response.data);
        }

        deleteKiosk(deviceId: string, drawerId?: string): angular.IPromise<any> {
            const uri = drawerId
                ? `${window["TippyMicroserviceUrl"]}/kiosk/${deviceId}?drawerId=${drawerId}`
                : `${window["TippyMicroserviceUrl"]}/kiosk/${deviceId}`;
            return this.$http.delete(uri, this.getShortcutConfig());
        }

        /**
        * Persists an update for the supplied entity.
        * @param {string} sectionEndpoint
        * @return {IPromise<any>} 
        */
        update(baseEndpoint: string, entity: any): angular.IPromise<any>;
        update(baseEndpoint: string, entity: any, sectionEndpoint?: string): angular.IPromise<any> {
            let uri = "";
            if (sectionEndpoint) {
                uri = `${window["TippyMicroserviceUrl"]}/${sectionEndpoint}`;
            } else {
                uri = `${window["TippyMicroserviceUrl"]}`;
            }
            return this.$http.put(uri, entity, this.getShortcutConfig())
                .then((response) => response.data);
        }

        /**
         * Unlock the kiosk
         * @param {string} deviceId 
         * @param {boolean} removeTransaction
         * @return {IPromise<any>}
         */
        unlockKiosk(deviceId: string): angular.IPromise<any> {
            let uri = `${window["TippyMicroserviceUrl"]}/kiosk/${deviceId}/lock`;
            return this.$http.delete(uri, this.getShortcutConfig());
        }

        /**
     * Allows the user to customize an API call his their specific needs. 
     * params: uri, method & data
     * @returns {} 
     */
        customMethodData(uri: string, method: string, data: any): angular.IPromise<any>;
        customMethodData(uri: string, method: string, data: any, params?: any): angular.IPromise<any> {
            let config: ng.IRequestConfig = {
                url: `${window["TippyMicroserviceUrl"]}/${uri}`,
                method: method,
                data: data,
                ...this.getShortcutConfig()
            }

            if (params) {
                config.params = params;
            }

            return this.$http(config)
                .then((res) => {
                    return res;
                });
        }

        private getShortcutConfig(): ng.IRequestShortcutConfig {
            return {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json;charset=utf-8"
                    , "Authorization": `Bearer ${window['bearerToken']}`
                }
            }
        }

        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings, $http: angular.IHttpService) => {
                return new TippyDataService(appSettings, $http);
            }

            svc.$inject = ["meevo.AppSettings", "$http"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.tippyDataService", TippyDataService.factory());
}